import { APP_VERSION } from '@/config/version';
import { Capacitor } from '@capacitor/core';
import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';

// export const useDishesStore = defineStore('dishes', {
export const useEnvStore = defineStore('env', () => {
  const isNative = Capacitor.isNativePlatform();

  const getApiUrl = () => {
    if (isNative) {
      // For mobile development, use your computer's IP address
      // Replace 192.168.0.113 with your actual IP address ('hostname -I' on Linux)
      return import.meta.env.VITE_MOBILE_API_URL || 'http://192.168.0.113:8000/api';
    }
    // For web development
    return `${window.location.origin}/api`;
  };

  const apiUrl: Ref<string> = ref(getApiUrl());
  const environment = ref(import.meta.env.VITE_MODE ? import.meta.env.VITE_MODE : import.meta.env.MODE);
  const lastUpdate = ref(import.meta.env.VITE_APP_LAST_UPDATE);
  const appVersion = ref(APP_VERSION);
  const imgGenApiUrl = ref(import.meta.env.VITE_IMAGE_GEN_API_URL);
  const imgGenApiKey = ref(import.meta.env.VITE_IMAGE_GEN_API_KEY);
  const defaultLocale = ref(import.meta.env.VITE_DEFAULT_LOCALE);
  const googleAnalyticsMeasurementId = ref(import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID);
  const googleClientId = ref(import.meta.env.VITE_GOOGLE_CLIENT_ID);
  const googleIOSClientId = ref(import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID);

  return {
    apiUrl,
    environment,
    lastUpdate,
    appVersion,
    imgGenApiKey,
    imgGenApiUrl,
    defaultLocale,
    googleAnalyticsMeasurementId,
    googleClientId,
    googleIOSClientId,
  };
});
